import axios from "../../../helper/axios";
import * as actionTypes from "../actionTypes";

export const fetchInfoStart = () => {
  return {
    type: actionTypes.FETCH_INFO_START,
  };
};

export const fetchInfoSuccess = (data) => {
  return {
    type: actionTypes.FETCH_INFO_SUCCESS,
    data,
  };
};

export const fetchInfoFail = (error) => {
  return {
    type: actionTypes.FETCH_INFO_FAIL,
    error,
  };
};

export const fetchUserInfo = () => {
  return (dispatch) => {
    dispatch(fetchInfoStart());
    axios
      .get("users/profile")
      .then((res) => {
        // console.log(res);
        dispatch(fetchInfoSuccess(res.data.userData));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchInfoFail(err.response.data.message));
        } else {
          dispatch(fetchInfoFail("Something went wrong"));
        }
      });
  };
};

// for Update
export const updateInfoStart = () => {
  return {
    type: actionTypes.UPDATE_INFO_START,
  };
};
export const updateInfoFail = (error) => {
  return {
    type: actionTypes.UPDATE_INFO_FAIL,
    error,
  };
};
export const updateInfoSuccess = (msg, newInfo) => {
  return {
    type: actionTypes.UPDATE_INFO_SUCCESS,
    msg,
    newInfo,
  };
};

// FOR AUTH FILE ONLY UPDATE NAME
export const updateFullNameInAuth = (fullName) => {
  return {
    type: actionTypes.UPDATE_FULLNAME,
    fullName,
  };
};

export const updateUserInfo = (arrData, firstName, lastName) => {
  return (dispatch) => {
    dispatch(updateInfoStart());
    console.log(arrData);
    axios
      .patch("users/profile", arrData)
      .then((res) => {
        // console.log(res);
        let fullName = firstName + " " + lastName;
        // console.log(arrData);
        localStorage.setItem("fullName", fullName);
        dispatch(updateFullNameInAuth(fullName));
        dispatch(updateInfoSuccess("Data has been updated", arrData));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(updateInfoFail(err.response.data.message));
        } else {
          dispatch(updateInfoFail("Something went wrong"));
        }
      });
  };
};

// for clear success
export const updateClearSuccess = () => {
  return {
    type: actionTypes.UPDATE_CLEAR_SUCCESS_MSG,
  };
};

// update password
export const passwordUpdateStart = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_START,
  };
};

export const passwordUpdateSuccess = (msg) => {
  return {
    type: actionTypes.UPDATE_PASSWORD_SUCCESS,
    msg,
  };
};

export const passwordUpdateFail = (error) => {
  return {
    type: actionTypes.UPDATE_PASSWORD_FAIL,
    error,
  };
};

// for clear errors
export const passwordUpdateClearError = () => {
  return {
    type: actionTypes.CLEAR_ERROR,
  };
};

export const updatePassword = (data) => {
  return (dispatch) => {
    dispatch(passwordUpdateStart());
    axios
      .patch("users/account/password", data)
      .then((res) => {
        console.log(res);
        dispatch(passwordUpdateSuccess("Data has been updated"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(passwordUpdateFail(err.response.data.message));
        } else {
          dispatch(passwordUpdateFail("Something went wrong"));
        }
      });
  };
};

// for user picture
// fetch pic
export const fetchPicStart = () => {
  return {
    type: actionTypes.FETCH_PIC_START,
  };
};

export const fetchPicSuccess = (pic) => {
  return {
    type: actionTypes.FETCH_PIC_SUCCESS,
    pic,
  };
};

export const fetchPicFail = (error) => {
  return {
    type: actionTypes.FETCH_PIC_FAIL,
    error,
  };
};

export const fetchPic = () => {
  return (dispatch) => {
    dispatch(fetchPicStart());
    axios
      .get("api/v1/user/profile/image")
      .then((res) => {
        // console.log(res);

        dispatch(
          fetchPicSuccess(
            "profileImage" in res.data ? res.data.profileImage.fileLink : null
          )
        );
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchPicFail(err.response.data.message));
        } else {
          dispatch(fetchPicFail("Something went wrong"));
        }
      });
  };
};

// Upload pic
export const uploadPicStart = () => {
  return {
    type: actionTypes.UPLOAD_PIC_START,
  };
};

export const uploadPicSuccess = (newPic, msg) => {
  return {
    type: actionTypes.UPLOAD_PIC_SUCCESS,
    newPic,
    msg,
  };
};

export const uploadPicFail = (error) => {
  return {
    type: actionTypes.UPLOAD_PIC_FAIL,
    error,
  };
};

export const uploadPic = (data) => {
  return (dispatch) => {
    dispatch(uploadPicStart());
    // console.log(data);
    axios
      .post(`api/v1/user/profile/image`, data, {
        onUploadProgress: (progressEvent) => {
          // console.log(
          //   'Upload Progress:' +
          //     ' ' +
          //     (progressEvent.loaded / progressEvent.total) * 100 +
          //     '%'
          // );
        },
      })
      .then((res) => {
        // console.log(res);
        dispatch(uploadPicSuccess(res.data.link, "SUCCESSFULLY UPLOADED"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(uploadPicFail(err.response.data.message));
        } else {
          dispatch(uploadPicFail("Something went wrong"));
        }
      });
  };
};
